import hashCode from './hash-code';

const KEY = 'key';

interface GenericObject {
  [k: string]: unknown;
}

export default function withKey(obj: object | GenericObject): GenericObject {
  const data = obj as GenericObject;
  if (typeof data[KEY] === 'undefined') {
    const asString = JSON.stringify(obj);

    return { ...obj, key: hashCode(asString) };
  }

  return data;
}
